var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIsMinified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.14286C10.4571 2.14286 12.8571 4.54286 12.8571 7.5C12.8571 10.4571 10.4571 12.8571 7.5 12.8571C4.54286 12.8571 2.14286 10.4571 2.14286 7.5C2.14286 4.54286 4.54286 2.14286 7.5 2.14286ZM7.5 0C3.35357 0 0 3.35357 0 7.5C0 11.6464 3.35357 15 7.5 15C11.6464 15 15 11.6464 15 7.5C15 3.35357 11.6464 0 7.5 0Z",
    fill: "#FF7E59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0603 8.08371C11.4996 8.08371 11.8638 7.71942 11.8638 7.28013C11.8638 6.84085 11.4996 6.47656 11.0603 6.47656H4.6317C4.19241 6.47656 3.82812 6.84085 3.82812 7.28013C3.82812 7.71942 4.19241 8.08371 4.6317 8.08371H11.0603Z",
    fill: "#FF7E59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsMinified);
export default __webpack_public_path__ + "static/media/is_minified.0664e7fd7187306eb0eac7cc34aa9313.svg";
export { ForwardRef as ReactComponent };